import { render } from "./ExamAten.vue?vue&type=template&id=01ecd98a&scoped=true"
import script from "./ExamAten.vue?vue&type=script&lang=js"
export * from "./ExamAten.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=01ecd98a&scoped=true&lang=css"
import "@/assets/css/tabla_estilizada.css?vue&type=style&index=1&id=01ecd98a&scoped=true&lang=css"
import "@/assets/css/microfono.css?vue&type=style&index=2&id=01ecd98a&scoped=true&lang=css"
import "@/assets/css/listaRegistros.css?vue&type=style&index=3&id=01ecd98a&scoped=true&lang=css"
import "./ExamAten.vue?vue&type=style&index=4&id=01ecd98a&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ecd98a"]])

export default __exports__